module.exports = __webpack_public_path__ + "static/media/PremiereProIcon.77481e41.svg";